import MiBackTop from './backtop';
import { install } from '../../utils/install';
export default install(MiBackTop);
